import styled from 'styled-components';
export const ChatCTACard = styled.div `
  position: relative;
  display: flex;
  text-align: center;
  align-items: center;
  padding: 10px;
  border: 1px solid ${({ theme, color }) => color || theme.button.background};
  border-radius: 4px;
  cursor: pointer;
`;
export const ChatCTABody = styled.div `
  width: 100%;
  margin-left: 2px;
`;
export const IconWrapper = styled.div `
  display: inline-block;
  text-align: center;
  margin-right: 10px;
  width: 48px;
  height: auto;
  color: ${({ theme, color }) => color || theme.button.background};
`;
